import { useOnlineStatus } from '@shared/hooks/useOnlineStatus';

/**
 * OfflineIndicator — MOB-041 (Lot 4).
 *
 * Bandeau discret, affiché uniquement quand `navigator.onLine === false`.
 * Le texte reflète ce qui est réellement vrai dans cette app (audit Lot 4) :
 * les données de travail (missions, opportunités, finances, devis, notes...)
 * vivent en local (Dexie/localStorage) et restent pleinement utilisables
 * hors connexion. Seules la validation de licence en ligne et la sauvegarde
 * cloud (fonctions explicitement réseau) nécessitent une reconnexion — cette
 * app NE prétend JAMAIS "vos données sont synchronisées" : il n'existe aucun
 * mécanisme de synchronisation distante des données de travail dans ce code.
 *
 * `role="status"`/`aria-live="polite"` : information non bloquante, pas une
 * alerte critique — cohérent avec la consigne "pas d'annonces permanentes
 * bruyantes".
 */
export function OfflineIndicator() {
  const isOnline = useOnlineStatus();
  if (isOnline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="offline-indicator"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '6px 14px',
        background: 'var(--ix-bg-subtle, #f1f5f9)',
        borderBottom: '1px solid var(--ix-border-subtle, #e2e8f0)',
        fontSize: 12,
        color: 'var(--ix-text-secondary, #475569)',
        lineHeight: 1.4,
      }}
    >
      <span aria-hidden="true" style={{ fontSize: 12 }}>●</span>
      <span>
        Hors connexion — vos missions, opportunités, finances et notes restent disponibles (données
        locales). La validation de licence et la sauvegarde cloud nécessitent une reconnexion.
      </span>
    </div>
  );
}
